// extracted by mini-css-extract-plugin
export default {"wrapper":"SectionHeading_wrapper__tQVpP","heading":"SectionHeading_heading__9yTT4","underline":"SectionHeading_underline__lAliA"};